// extracted by mini-css-extract-plugin
export default {"wrapper":"arrow_wrapper__tXyC+","icon":"arrow_icon__nmiTy"};